import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';
import Title from './title';
import Content from './content';
import EditButton from './editButton';

const HeaderProfilePanel = ({
  activatorUser = null,
  closePanel = null,
  content = [],
  name = null,
  strings,
}) => {
  const replaceMap = { name: activatorUser };

  return (
    <div className="vf-header-profile__panel">
      <Title>
        {name}
      </Title>

      {content.map(item => (
        <Content
          iconClassName={item.iconClassName}
          iconText={item.iconText}
          key={item.iconClassName}
        >
          {item.text}
        </Content>
      ))}

      {!Utils.Helper.isNullOrUndefined(activatorUser) ? (
        <div className="vf-header-profile__panel__activation">
          {Utils.TranslationHelper.replaceTag(strings.activation, replaceMap)}
        </div>
      ) : (
        <EditButton onClick={closePanel} />
      )}
    </div>
  );
};

HeaderProfilePanel.displayName = 'Header Profile Panel';

HeaderProfilePanel.propTypes = {
  activatorUser: PropTypes.string,
  closePanel: PropTypes.func,
  content: PropTypes.arrayOf(PropTypes.shape({
    iconClassName: PropTypes.string,
    iconText: PropTypes.string,
    text: PropTypes.string,
  })),
  name: PropTypes.string,
  strings: PropTypes.shape().isRequired,
};

export default translate('HeaderProfile')(HeaderProfilePanel);
